import { Moon } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";

export const DEFAULT_QUIET = { on: false, start: "00:00", end: "07:00" };

// Waktu Rehat: Mod Latar stays ON but does not post inside this window.
export default function QuietHoursControl({ value, onChange, disabled }) {
  const q = { ...DEFAULT_QUIET, ...(value || {}) };
  const set = (patch) => onChange({ ...q, ...patch });
  return (
    <div className="mt-3 rounded-md border border-indigo-500/20 bg-background/40 p-3" data-testid="bg-quiet-row">
      <label className="flex items-center justify-between gap-3">
        <span className="flex items-center gap-2 text-xs text-indigo-100"><Moon className="h-3.5 w-3.5" /> Waktu Rehat Automatik (tiada post dalam tempoh ini)</span>
        <Switch checked={q.on} disabled={disabled} onCheckedChange={(on) => set({ on })} data-testid="bg-quiet-toggle" />
      </label>
      {q.on && (
        <div className="mt-2 flex flex-wrap items-center gap-2 text-xs text-indigo-100">
          Dari <Input type="time" value={q.start} disabled={disabled} onChange={(e) => e.target.value && set({ start: e.target.value })} className="h-8 w-[110px] border-indigo-500/30 bg-background text-xs" data-testid="bg-quiet-start" />
          hingga <Input type="time" value={q.end} disabled={disabled} onChange={(e) => e.target.value && set({ end: e.target.value })} className="h-8 w-[110px] border-indigo-500/30 bg-background text-xs" data-testid="bg-quiet-end" />
          <span className="text-indigo-200/70">Mod Latar kekal AKTIF & sambung sendiri selepas waktu rehat.</span>
        </div>
      )}
    </div>
  );
}
